(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quick-view"]) return;
  try {
    
  class FsQuickView extends HTMLElement {
    constructor() {
      super();
      this._onTrigger = this._onTrigger.bind(this);
      this._onKey = this._onKey.bind(this);
    }
    connectedCallback() {
      document.addEventListener('click', this._onTrigger);
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-fs-close]')) this.close();
      });
      document.addEventListener('keydown', this._onKey);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this._onTrigger);
      document.removeEventListener('keydown', this._onKey);
    }
    _onTrigger(e) {
      const trigger = e.target.closest('[data-fs-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      const handle = trigger.getAttribute('data-fs-quick-view');
      if (handle) this.open(handle);
    }
    _onKey(e) {
      if (e.key === 'Escape' && !this.hidden) this.close();
    }
    async open(handle) {
      this.hidden = false;
      document.documentElement.classList.add('fs-no-scroll');
      try {
        const res = await fetch(`/products/${handle}?view=quick-view`, { headers: { 'Accept': 'text/html' } });
        const html = await res.text();
        const body = this.querySelector('[data-fs-body]');
        body.innerHTML = html;
        this._initProduct(body);
        const focusable = this.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusable) focusable.focus();
      } catch (err) {
        console.error('[fs-quick-view]', err);
      }
    }
    close() {
      this.hidden = true;
      document.documentElement.classList.remove('fs-no-scroll');
      const body = this.querySelector('[data-fs-body]');
      if (body) body.innerHTML = '';
    }
    _initProduct(root) {
      root.querySelectorAll('[data-qv-product]:not([data-qv-ready])').forEach((section) => {
        section.dataset.qvReady = 'true';
        const data = section.querySelector('[data-qv-variants]');
        const variants = data ? JSON.parse(data.textContent).variants : [];
        const options = [...section.querySelectorAll('[data-qv-option]')];
        const variantInput = section.querySelector('[data-qv-variant-id]');
        const price = section.querySelector('[data-qv-price]');
        const compare = section.querySelector('[data-qv-compare]');
        const add = section.querySelector('[data-qv-add]');

        options.forEach((select) => {
          [...select.options].forEach((option) => {
            option.dataset.baseLabel = option.textContent;
          });
        });

        const getSelected = () => {
          const positions = [...new Set(options.map((option) => Number(option.dataset.optionPosition)))].sort((a, b) => a - b);
          return positions.map((position) => section.querySelector(`[data-qv-option][data-option-position="${position}"]`)?.value || '');
        };

        const getDefaultVariant = () => {
          const currentId = variantInput?.value;
          return variants.find((variant) => String(variant.id) === String(currentId)) || variants[0] || null;
        };

        const updateOptionAvailability = (selected) => {
          options.forEach((select) => {
            const position = Number(select.dataset.optionPosition || 1);
            [...select.options].forEach((option) => {
              const candidate = [...selected];
              candidate[position - 1] = option.value;
              const candidateVariant = variants.find((item) => item.options.every((variantOption, index) => variantOption === candidate[index]));
              const unavailable = !candidateVariant || !candidateVariant.available;
              option.dataset.available = String(!unavailable);
              option.textContent = unavailable ? `${option.dataset.baseLabel} - Esaurito` : option.dataset.baseLabel;
            });
          });
        };

        const update = () => {
          const selected = getSelected();
          updateOptionAvailability(selected);
          const variant = options.length
            ? variants.find((item) => item.options.every((option, index) => option === selected[index]))
            : getDefaultVariant();
          const unavailableLabel = add?.dataset.unavailableLabel || 'Non disponibile';
          const addLabel = add?.dataset.addLabel || 'Aggiungi al carrello';
          const soldOutLabel = add?.dataset.soldOutLabel || 'Esaurito';

          if (!variant) {
            if (variantInput) variantInput.value = '';
            if (add) {
              add.disabled = true;
              add.textContent = unavailableLabel;
            }
            return;
          }

          if (variantInput) variantInput.value = variant.id;
          if (price) price.textContent = variant.price_formatted;

          const compareAt = Number(variant.compare_at_price || 0);
          const currentPrice = Number(variant.price || 0);
          if (compare) {
            compare.hidden = compareAt <= currentPrice;
            compare.textContent = compareAt > currentPrice ? variant.compare_at_price_formatted : '';
          }
          if (add) {
            add.disabled = !variant.available;
            add.textContent = variant.available ? addLabel : soldOutLabel;
          }
        };

        options.forEach((option) => option.addEventListener('change', update));
        update();
      });
    }
  }
  if (!customElements.get('fs-quick-view')) customElements.define('fs-quick-view', FsQuickView);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  class FsShopTheLook extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-fs-hotspot]');
        if (!btn) return;
        const idx = btn.getAttribute('data-fs-hotspot');
        this.querySelectorAll('[data-fs-card]').forEach(card => {
          card.hidden = card.getAttribute('data-fs-card') !== idx;
        });
        this.querySelectorAll('[data-fs-hotspot]').forEach(h => {
          h.setAttribute('aria-expanded', h === btn ? 'true' : 'false');
        });
      });
    }
  }
  if (!customElements.get('fs-shop-the-look')) customElements.define('fs-shop-the-look', FsShopTheLook);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart"] && !Shopify.designMode) return;
  try {
    
  class FsSizeChart extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const open = event.target.closest('[data-fs-open]');
        const close = event.target.closest('[data-fs-close]');
        const modal = this.querySelector('.fs-size-chart__modal');
        if (!modal) return;

        if (open) {
          modal.hidden = false;
          document.documentElement.classList.add('fs-no-scroll');
        }

        if (close) {
          modal.hidden = true;
          document.documentElement.classList.remove('fs-no-scroll');
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const modal = this.querySelector('.fs-size-chart__modal');
        if (modal && !modal.hidden) {
          modal.hidden = true;
          document.documentElement.classList.remove('fs-no-scroll');
        }
      });
    }
  }

  if (!customElements.get('fs-size-chart')) customElements.define('fs-size-chart', FsSizeChart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  class FsStoreLocator extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('[data-fs-filter]');
      const empty = this.querySelector('[data-fs-empty]');
      if (!input) return;

      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        let visible = 0;

        this.querySelectorAll('[data-fs-store]').forEach((item) => {
          const haystack = `${item.dataset.city || ''} ${item.dataset.country || ''}`;
          const show = !query || haystack.includes(query);
          item.hidden = !show;
          if (show) visible += 1;
        });

        if (empty) empty.hidden = visible > 0;
      });
    }
  }

  if (!customElements.get('fs-store-locator')) customElements.define('fs-store-locator', FsStoreLocator);

  } catch(e) { console.error(e); }
})();
})();
